import React from 'react';
import { Link } from 'react-router-dom';
import agent from '../agent';
import { connect } from 'react-redux';
import moment from 'moment';
import { ANSWER_FAVORITED, ANSWER_UNFAVORITED } from '../constants/actionTypes';
import './answer-card.css';

const mapDispatchToProps = dispatch => ({
  favorite: id => dispatch({
    type: ANSWER_FAVORITED,
    payload: agent.Articles.favorite(id)
  }),
  unfavorite: id => dispatch({
    type: ANSWER_UNFAVORITED,
    payload: agent.Articles.unfavorite(id)
  }),
});

const mapStateToProps = state => ({
  profile: state.profile
});

class AnswerCard extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const profile = this.props.profile
    const article = this.props.article;
    const handleClick = ev => {
      ev.preventDefault();
      if (this.props.currentUser && this.props.currentUser.verified && this.props.currentUser.openid && this.props.currentUser.preferredName) {
        if (this.props.blackout) {
          this.props.handleBlackout();
        }
        else if (article.hasVoted === '1') {
          this.props.unfavorite(article.id);
        } else {
          this.props.favorite(article.id);
        }
      } else {
        this.props.handleLogin()
      }
    };

    const getInitials = (fullName) => {
      let nameArr = fullName.split(" ")
      let initials = nameArr.map((n, i) => {
        return (i == 0 || i == nameArr.length - 1) && n[0]
      }).filter(n => n).join("")
      return initials
    }

    return (
      <div className="question-preview">
        <div className="question-top-container">
          <div className="question-left-container">
          </div>
          <div className="question-ctr-container">
            <div className="avatar">
              {getInitials(article.user.fullName ? article.user.fullName: article.user.preferredName)}
            </div>
            <div className="qn-meta-data">
              <div className="asker">
                {article.user.fullName ? article.user.fullName : article.user.preferredName}
              </div>
              <div className="timestamp">
                asked on {moment(article.createdAt).format('D MMMM YYYY')}
              </div>
            </div>
          </div>
          <div className="question-right-container">
            <div className="question-stats">
              <div className={article.hasVoted === '1' ? 'favorite' : 'not-favorite'}>
                {article.voteCount}
              </div>
              <div onClick={handleClick}>
                <i className={article.hasVoted === '1' ? 'bx bxs-heart' : 'bx bx-heart'}></i>
              </div>
            </div>
          </div>
        </div>
        <div className="question-bottom-container">
          <div className="question-text">
            {article.content}
          </div>
          <div className="answer-container">
            <img src={profile.image} className="avatar" />
            <div className="qn-meta-data">
              <div className="asker">
                {profile.name}
              </div>
              <div className="timestamp">
                answered on {moment(profile.createdAt).format('D MMMM YYYY')}
              </div>
            </div>
          </div>
          <div className="answer-text">
            {article.answer.content}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AnswerCard);



// WEBPACK FOOTER //
// ./src/components/AnswerCard.js